import { useApplePayPayment, useCashAppPay, useSavedBankAccounts, useSavedCards } from '../../state'

export const useHasPaymentMethods = (): boolean => {
  const cashAppPay = useCashAppPay()
  const savedCards = useSavedCards()
  const applePayEnabled = useApplePayPayment()
  const savedBankAccounts = useSavedBankAccounts()

  return cashAppPay.length > 0 || savedCards.length > 0 || applePayEnabled || (savedBankAccounts?.length ?? 0) > 0
}
